// Browser-side HS256 JWT helpers on top of Web Crypto (jose).
// Replaces `jsonwebtoken`, which is Node-only and needs crypto/stream polyfills under webpack 5.
import { SignJWT, jwtVerify } from 'jose'

const toKey = secret => new TextEncoder().encode(secret)

export function sign(payload, secret, { expiresIn } = {}) {
  let token = new SignJWT({ ...payload })
    .setProtectedHeader({ alg: 'HS256', typ: 'JWT' })
    .setIssuedAt()
  if (expiresIn) token = token.setExpirationTime(expiresIn)
  return token.sign(toKey(secret))
}

export async function verify(token, secret) {
  const { payload } = await jwtVerify(token, toKey(secret))
  return payload
}

export default { sign, verify }
